<template>
    <div class="wrapper-style quiz-style rd-approach">
        <div class="fix-bg">
            <div class="bgview">
                <div class="inner-wave-bt"></div>
            </div>
        </div>
        <div class="page-box">
            <div class="bgview">
                <div class="header">
                    <div class="view">
                        <div class="left">
                            <div class="header-funnow-logo">
                                <div class="bgshow"></div>
                            </div>
                        </div>
                        <div class="header-event-logo">
                            <div class="bgshow"></div>
                        </div>
                    </div>
                </div>
                <div class="quiz-box">
                    <div class="area-box">
                        <div class="box-view">
                            <div class="line-b"></div>
                            <div class="line-t"></div>
                            <div class="line-r"></div>
                            <div class="line-l"></div>
                            <div class="bg-t-l">
                                <div class="bgshow"></div>
                            </div>
                            <div class="bg-t-r">
                                <div class="bgshow"></div>
                            </div>
                            <div class="bg-b-l">
                                <div class="bgshow"></div>
                            </div>
                            <div class="bg-b-r">
                                <div class="bgshow"></div>
                            </div>
                            <div class="view">
                                <div class="area-tit">
                                    <div class="show" v-text="'問題'+this.step_name">問題壹</div>
                                </div>
                                <ul class="quiz-ul">
                                    <transition name="fade" mode="out-in">
                                        <template v-for="(question, index) in questions">
                                            <div v-if="index === 0 && index === step" :key="index">
                                                <p class="q-des-show" v-text="question.question"></p>
                                                <ul class="quiz-list">
                                                    <template v-for="answer in question.answers">
                                                        <li>
                                                            <p v-text="answer.name" v-on:click="selectAnswer($event, answer.score)"></p>
                                                            <div class="li-line-t"></div>
                                                            <div class="li-line-b"></div>
                                                            <div class="li-line-l"></div>
                                                            <div class="li-line-r"></div>
                                                        </li>
                                                    </template>
                                                </ul>
                                            </div>
                                            <div v-if="index !== 0 && index === step" :key="index">
                                                <p class="q-des-show" v-text="question.question"></p>
                                                <ul class="quiz-list">
                                                    <template v-for="answer in question.answers">
                                                        <li>
                                                            <p v-text="answer.name" v-on:click="selectAnswer($event, answer.score)"></p>
                                                            <div class="li-line-t"></div>
                                                            <div class="li-line-b"></div>
                                                            <div class="li-line-l"></div>
                                                            <div class="li-line-r"></div>
                                                        </li>
                                                    </template>
                                                </ul>
                                            </div>
                                        </template>
                                    </transition>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="quiz-number" v-text="(step+1)+'/5'"></div>
            </div>
        </div>
    </div>
</template>

<script>

import LottieAnimation from 'lottie-web-vue'
import {gsap} from "gsap";
import questions from '../questions.json'

export default {
    name:"Questionnaire",
    props: ["path", "uid"],
    components:{
        LottieAnimation
    },
    data() {
        return {
            step:0,
            step_name:'一',
            answers:[],
            allow:true,
            questions: questions
        }
    },
    methods: {
        selectAnswer: function (event, answer) {
            const _this = this
            if(this.allow){
                _this.allow = false

                event.currentTarget.closest('li').querySelectorAll('.quiz-list').forEach(function (item) {
                    item.classList.remove('on')
                })

                event.currentTarget.classList.add('on')

                setTimeout(function () {
                    _this.allow = true
                    if(_this.step<4){
                        _this.answers.push(answer)
                        _this.step++
                        _this.$gtag.event('view_question_'+ (parseInt(_this.step)+1))
                        _this.stepName()
                    }
                }, 300)


                if(_this.step === 4){
                    _this.answers.push(answer)
                    _this.build()
                }

            }
        },
        build: function () {
            const index = _.random(0, 1);
            this.$emit('update-result', this.answers.join(''), index)
            this.$emit('switch-component', 'loading')
        },
        stepName(){
            if(this.step === 0){
                this.step_name = '一'
            }else if(this.step === 1){
                this.step_name = '二'
            }else if(this.step === 2){
                this.step_name = '三'
            }else if(this.step === 3){
                this.step_name = '四'
            }else if(this.step === 4){
                this.step_name = '五'
            }

        }
    },
    mounted: function () {
        this.$gtag.event('view_question_1')
        this.$emit('approach-animate')
    },
    watch: {
    }
}
</script>

<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
    transition: opacity .2s ease;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
